export default class ListUtils {
  /**
   * 型月のリストを取得する
   * @name getList
   * @return {Array} new Array
   */
  public static getList<T>() {
    return new Array<T>();
  }
}
